import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
export const SendUploadForm = ({ upload, onClose }) => {
    const { token, base_url } = useAppContext();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [email, setEmail] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;
        if (!email.trim()) {
            window.showAlert(400, 'Please enter an email address.');
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(`${base_url}/apis/uploads/${upload.id}/send-email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: token },
                body: JSON.stringify({ email: email.trim() }),
            });

            const data = await response.json();

            if (!response.ok) {
                const err = new Error(data?.msg || data?.message);
                err.status = response.status;
                err.msg = data?.msg || data?.message;
                throw err;
            }

            window.showAlert(200, data?.msg || 'Upload sent successfully!');
            setEmail('');
            onClose();
        } catch (error) {
            console.error('Error sending upload:', error);
            if (error.status === 404) {
                window.showAlert(404, 'Upload not found');
            } else if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, error.msg || 'Failed to send upload. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to send upload. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const sendUploadForm = (
        <div>
            <h2>Send Upload</h2>
            <p>Send this file via email to a recipient.</p>
            <p>
                <strong>File: {upload?.upload_name}</strong>
            </p>
            <div className="form-group">
                <label htmlFor="email">Recipient Email Address:</label>
                <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter email address"
                    className="form-input"
                    disabled={isSubmitting}
                    required
                />
            </div>

            <div className="form-actions">
                <button
                    type="button"
                    onClick={() => onClose()}
                    className="btn btn-secondary"
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary"
                    disabled={isSubmitting || !email.trim()}
                >
                    {isSubmitting ? (
                        <>
                            <FontAwesomeIcon icon={faSpinner} spin /> Sending...
                        </>
                    ) : (
                        'Send'
                    )}
                </button>
            </div>
        </div>
    );

    return <Modal form={sendUploadForm} setIsModalOpen={() => onClose()} />;
};
